<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">
            <span i18n>Purchase order sourcing</span>
        </h5>
        <button (click)="close()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p *ngIf="!creditors" class="text-muted" i18n>Loading...</p>

        <ng-container *ngIf="creditors">

            <table class="table">
                <thead>
                    <tr>
                        <td i18n>Product</td>
                        <td class="text-right" i18n>Quantity</td>
                        <td></td>
                    </tr>
                </thead>

                <tbody *ngFor="let orderLine of _order.order_lines">
                    <tr>
                        <td>{{ orderLine.product.name }} ({{ orderLine.product.creditor_id }})</td>
                        <td class="text-right">{{ orderLine.quantity }}</td>
                        <td class="text-right">
                            <button class="btn  btn-xs  btn-primary" (click)="addSource(orderLine)"><fa-icon style="vertical-align: -2px;" [icon]="faCodeFork"></fa-icon></button>
                        </td>
                    </tr>

                    <ng-container *ngIf="sourcedLines[orderLine.id]">
                        <tr *ngFor="let source of sourcedLines[orderLine.id]; let i = index">
                            <td>
                                <div class="form-group">
                                    <label for="source-{{i}}-creditor" i18n>Creditor</label>
                                    <select id="source-{{i}}-creditor" class="form-control  form-control-sm" [(ngModel)]="source.creditor" name="creditor">
                                        <option [ngValue]="null" i18n>-- Select creditor --</option>
                                        <option *ngFor="let creditor of creditors" [ngValue]="creditor.id">{{ creditor.name }}</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <label for="source-{{i}}-quantity" i18n>Quantity</label>
                                    <input id="source-{{i}}-quantity" type="number" min="1" class="form-control  form-control-sm" [(ngModel)]="source.quantity">
                                </div>
                            </td>
                            <td class="text-right">
                                <button class="btn  btn-xs  btn-danger" (click)="removeSource(orderLine, source)"><fa-icon style="vertical-align: -2px;" [icon]="faTrash"></fa-icon></button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving" i18n>Close</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving || !isSourceNotEmptyAndValid()">
            <ng-container *ngIf="saving" i18n>Saving...</ng-container>
            <ng-container *ngIf="!saving" i18n>Save</ng-container>
        </button>
    </div>
</div>
